(() => {
  if (window.aknesComplementaryProductsLoaded) return;
  window.aknesComplementaryProductsLoaded = true;

  const SELECTOR = '[data-aknes-complementary]';
  const READY = 'aknesComplementaryReady';

  const setState = (root, state) => {
    root.dataset.state = state;
  };

  const renderManualFallback = (root) => {
    const manualTemplate = root.querySelector('[data-aknes-complementary-manual-template]');

    if (root.dataset.source === 'search_discovery_fallback' && manualTemplate?.innerHTML.trim().length) {
      root.innerHTML = manualTemplate.innerHTML;
      root.dataset.hasRecommendations = 'manual';
      setState(root, 'manual');
      return true;
    }

    return false;
  };

  const renderEditorEmpty = (root, state = 'empty', fresh = null) => {
    if (!window.Shopify?.designMode) return false;

    const emptyTemplate =
      fresh?.querySelector('[data-aknes-complementary-empty-template]') ||
      root.querySelector('[data-aknes-complementary-empty-template]');

    if (emptyTemplate?.innerHTML.trim().length) {
      root.innerHTML = emptyTemplate.innerHTML;
    } else {
      root.innerHTML =
        '<div class="aknes-complementary-inner aknes-complementary-empty"><p class="aknes-complementary-empty-title">No complementary products found.</p><p class="aknes-complementary-empty-text">Add products in Shopify Search & Discovery,<br>or switch the source to Manual products.</p></div>';
    }

    root.classList.add('aknes-complementary--empty');
    root.dataset.hasRecommendations = 'false';
    setState(root, state);
    return true;
  };

  const loadComplementary = async (root) => {
    const url = root.dataset.url;

    if (!url) {
      if (renderManualFallback(root) || renderEditorEmpty(root, 'error')) return;
      root.remove();
      return;
    }

    root.aknesComplementaryAbort?.abort();
    const abortController = new AbortController();
    root.aknesComplementaryAbort = abortController;
    setState(root, 'loading');

    try {
      const response = await fetch(url, {
        cache: 'no-store',
        credentials: 'same-origin',
        signal: abortController.signal,
      });

      if (!response.ok) {
        if (renderManualFallback(root) || renderEditorEmpty(root, 'error')) return;
        root.remove();
        return;
      }

      const text = await response.text();
      const html = document.createElement('div');
      html.innerHTML = text;

      const id = root.dataset.aknesComplementaryId;
      const fresh = id
        ? Array.from(html.querySelectorAll(SELECTOR)).find((item) => item.dataset.aknesComplementaryId === id)
        : html.querySelector(SELECTOR);

      if (fresh?.dataset.hasRecommendations === 'true' && fresh.innerHTML.trim().length) {
        root.replaceWith(fresh);
        setState(fresh, 'loaded');
        initComplementary(fresh);
        return;
      }

      if (renderManualFallback(root)) return;

      if (renderEditorEmpty(root, 'empty', fresh)) return;

      root.remove();
    } catch (_error) {
      if (abortController.signal.aborted) return;
      if (renderManualFallback(root) || renderEditorEmpty(root, 'error')) return;
      root.remove();
    } finally {
      if (root.aknesComplementaryAbort === abortController) {
        root.aknesComplementaryAbort = null;
      }
    }
  };

  const initComplementary = (root) => {
    if (!root || root.dataset[READY] === 'true') return;

    root.dataset[READY] = 'true';

    if (root.dataset.hasRecommendations === 'true') return;

    const source = root.dataset.source || 'search_discovery_fallback';

    if (source === 'manual') {
      if (root.dataset.hasManualProducts !== 'true' && !window.Shopify?.designMode) {
        root.remove();
      }
      if (root.dataset.hasManualProducts === 'true') {
        setState(root, 'manual');
      } else {
        renderEditorEmpty(root, 'empty');
      }
      return;
    }

    const load = () => loadComplementary(root);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0]?.isIntersecting) return;
          observer.unobserve(root);
          load();
        },
        { rootMargin: '0px 0px 300px 0px' }
      );

      observer.observe(root);
      root.aknesComplementaryObserver = observer;
    } else {
      load();
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(initComplementary);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(SELECTOR).forEach((root) => {
      root.aknesComplementaryAbort?.abort();
      root.aknesComplementaryObserver?.disconnect();
    });
  });
})();
